/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import { Form, Image } from 'react-bootstrap';
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector } from "react-redux";
import { WebSocketContext } from "../../../App";
import CommonDateTime from "../../Common/CommonDateTime";
import ExelIcon from "../../../assets/img/XLS_icon.svg";
import CommonTable from "../../Common/CommonTable";
import CommonReactSelectMenu from "../../Common/CommonReactSelectMenu";
import CommonDatePicker from "../../Common/CommonDatePicker";
import ExportToCSV from "../../Common/ExportToCSV";

const ErpStockLevel = (props) => {
    const { websocket } = useContext(WebSocketContext);
    const { device_id, erpStoredLevelReportList, wareHouselistall, productlistall, selfInfo } = useSelector((state) => state.adminReducers);
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ selectWarehouse, setselectWarehouse ] = useState("");
    const [ selectProduct, setselectProduct ] = useState("");
    const [ FromEndDate, setFromEndDate ] = useState([null, null]);
    const [ FromDate, ToDate ] = FromEndDate;
    const optionsWarehouse = wareHouselistall?.filter((elm) => elm?.is_active === true)?.map((item, index) => ({ key: item.id, value: item?.id, label: `${item?.warehouse_name} - (${item?.warehouse_code})- (${item?.display_name})` }));
    const optionsProducts = productlistall?.map((item, index) => ({ key: item.id, value: item?.id, label: item?.product_name }));
    const PermissionsAccess = selfInfo?.user?.permissions_access;

    // get all city list
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Store[5]?.Edit || PermissionsAccess?.Store[5]?.View)) {
            let param = {
                "transmit": "broadcast",
                "url": "product_list",
                "request": {
                    "status": true,
                    "limit": 5000,
                    "page_no": 1,
                    "search": ""
                },
                "DeviceId": device_id
            };
            wsSend_request(websocket, param);
        };
    }, [ websocket ]);

    // get all warehouse list
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Store[5]?.Edit || PermissionsAccess?.Store[5]?.View)) {
            let param = {
                "transmit": "broadcast",
                "url": "warehouse_list",
                "request": {
                    "status": "",
                    "limit": 5000,
                    "page_no": 1,
                    "search": ""
                },
                "DeviceId": device_id
            };
            wsSend_request(websocket, param);
        }
    }, [ websocket ]);

    // api calling
    const APICall = () => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Store[5]?.Edit || PermissionsAccess?.Store[5]?.View)) {
            let param = {
                "transmit": "broadcast",
                "url": "erp_stock_level_list",
                "request": {
                    "status": "",
                    "limit": userLimit,
                    "page_no": currentPage,
                    "search": "",
                },
                "DeviceId": device_id
            };
            if (selectWarehouse !== "" && selectWarehouse !== null) {
                param.request.warehouse_id = selectWarehouse.value;
            };
            if (selectProduct !== "" && selectProduct !== null) {
                param.request.product_id = selectProduct.value;
            };
            if ((FromDate !== "" && FromDate !== null) && (ToDate !== "" && ToDate !== null)) {
                param.request.from_date = CommonDateTime(FromDate, "YYYY-MM-DD", "hide");
                param.request.to_date = CommonDateTime(ToDate, "YYYY-MM-DD", "hide");
            };
            wsSend_request(websocket, param);
        };
    };

    // get product list
    useEffect(() => {
        APICall();
    }, [ websocket, currentPage, userLimit, selectWarehouse, selectProduct, ToDate]);

    // page change
    const currentFunction = (page) => {
        setCurrentPage(page);
    };

    // select limit
    const SelectLimitFct = (e) => {
        setUserLimit(parseInt(e.target.value));
        setCurrentPage(1);
    };

    // TABLE COLUMNS ARRAY
    const TableColumns = [
        { key: 'last_updated_at', label: 'Updated On', type: "date_time_erp", sort: "", isCollapsable: false },
        { key: 'product_code', label: 'Product Code', type: "label", sort: "", isCollapsable: false },
        { key: 'product_name', label: 'Product Name', type: "label", sort: "", isCollapsable: false },
        { key: 'warehouse_name', label: 'Warehouse Name', type: "label", sort: "", isCollapsable: false },
        { key: 'balance_qty', label: 'Balance Stock', type: "label_stock_transfer", sort: "", isCollapsable: false },
    ];

    return (<section className="Main_section">
        <div className="filtr_Form" style={{ borderBottom: "1px solid #eee" }}>
            <div className="formloginset">
                <div className="row">
                    <div className="col-md-3">
                        <CommonDatePicker 
                            dateRange={FromEndDate} 
                            setDateRange={setFromEndDate}
                            placeholderText={"Select From Date & To Date"}
                            dependantState={{
                                allow: true,
                                statType: "current_page",
                                stateFunction: setCurrentPage
                            }} 
                            daysValidation={"15"}
                        />
                    </div>
                    <div className="col-md-3">
                        {(selfInfo?.user?.user_type === 'super_admin' || selfInfo?.user?.user_type === 'admin' || selfInfo?.user?.user_type === 'regional_sales_team_asm' || selfInfo?.user?.user_type === 'regional_manager' || selfInfo?.user?.user_type === 'regional_sales_team_rm' || selfInfo?.user?.user_type === 'warehouse_manager') && (<Form.Group className="mb-3">
                            <CommonReactSelectMenu 
                                label={"Warehouse"}
                                options={optionsWarehouse} 
                                selectValue={selectWarehouse} 
                                setSelectValue={setselectWarehouse} 
                                dependantState={{
                                    allow: true,
                                    statType: "current_page",
                                    stateFunction: setCurrentPage
                                }} 
                                isMendatory={false}
                                isAllowClearable={true}
                                customWidth={"100%"}
                                customeHeight={"38px"}
                                isMulti={false}
                            />
                        </Form.Group>)}
                    </div>
                    <div className="col-md-3">
                        <Form.Group className="mb-3">
                            <CommonReactSelectMenu
                                label={"Product"}
                                options={optionsProducts} 
                                selectValue={selectProduct}
                                setSelectValue={setselectProduct} 
                                dependantState={{
                                    allow: true,
                                    statType: "current_page",
                                    stateFunction: setCurrentPage
                                }} 
                                isMendatory={false}
                                isAllowClearable={true}
                                customWidth={"100%"}
                                customeHeight={"38px"}
                                isMulti={false}
                            />
                        </Form.Group>
                    </div>
                    <div className="col-md-3" style={{ display: "flex", alignItems: "flex-start" }}>
                        <select className="form-control userLimitselect" id="userLimitselect" value={userLimit} onChange={(e) => SelectLimitFct(e)}>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="40">40</option>
                            <option value="50">50</option>
                            <option value="60">60</option>
                            <option value="70">70</option>
                            <option value="80">80</option>
                            <option value="90">90</option>
                            <option value="100">100</option>
                        </select>
                        <button 
                            className="btn exportbtn" 
                            id="stocklevelExportbtn" 
                            style={{ width: "auto", float: "right" }} 
                            onClick={() => ExportToCSV("Erp-Stock-Level-List")}
                        >
                            <Image src={ExelIcon} alt="excel" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        {/* COMMON TABLE */}
        <CommonTable 
            isTableAllow={true}
            style={{
                height: parseInt(erpStoredLevelReportList?.pagination?.total_records) === erpStoredLevelReportList?.list?.length ? "calc(100vh - 159px)" : parseInt(erpStoredLevelReportList?.pagination?.total_records) > 10 ? "calc(100vh - 194px)" : "calc(100vh - 159px)"
            }}
            srNumber={{
                clickable: false,
                events: ""
            }}
            isCollapsable={false}
            tabName={"Erp-Stock-Level-List"} // TAB URL
            PaginationCurrentPage={currentPage} // TAB CURRENT PAGE
            PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
            TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
            OrderList={erpStoredLevelReportList} // ORDER LIST
            Pagination={erpStoredLevelReportList?.pagination} // CURRENT TAB PAGINATION
            EditAccess={false} // EDITABLE ACCESS STATE
            APIcalling={""}
            isActionColumnAvailable={{
                isShow: false,
                label: "",
                naviagte: null
            }}
            isActionTwoColumnAvailable={{
                isShow: false,
                url: "",
            }}
            isTotalAndGrand={{
                isShow: false,
                filterType: "",
                colSpan: 0,
                lastColspan: 0
            }}
            isOdiFilterRowColorsAllow={false}
        />
    </section>)
}

export default ErpStockLevel;